// import { FormsModule } from '@angular/forms';
// import { CustomerComponent } from './customer.component';
// import { NewItemDirective } from './new-item.directive';
// import { OrdersPipe } from './orders.pipe';
var SharedLibrariesModule = /** @class */ (function () {
    function SharedLibrariesModule() {
    }
    return SharedLibrariesModule;
}());
export { SharedLibrariesModule };



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared-libraries.module.ts.pre-build-optimizer.js